export default __webpack_public_path__ + "static/media/arrow_down.b5b05cd0.svg";